import { instance } from "@src/util/request";
import { chatOrigin } from "@src/util/runtimeConfig";

export async function getConversationById(params: any, token: string) {
  return instance(chatOrigin, {
    url: `/api/chat/conversation`,
    options: {
      method: "get",
      params,
      headers: {
        "x-access-token": token,
      },
    },
  });
}

export async function chatLogin(username: string, password: string) {
  return instance(chatOrigin, {
    url: `/api/login`,
    options: {
      method: "post",
      data: {
        username,
        password,
      },
    },
  });
}
